<template>
  <tab-bar>
    <tab-bar-item path="/home" activeColor="blue">
      <img slot="item-icon" src="~assets/img/tabbar/home.svg" alt="">
      <img slot="item-icon-active" src="~assets/img/tabbar/home_active.svg" alt="">
      <div slot="item-text">首页</div>
    </tab-bar-item>
    <!--    <tab-bar-item v-if="selectShow" path="/select" active-color="deepskyblue">-->
    <!--      <img slot="item-icon" src="~assets/img/tabbar/class.svg" alt="">-->
    <!--      <img slot="item-icon-active" src="~assets/img/tabbar/class_active.svg" alt="">-->
    <!--      <div slot="item-text">选课</div>-->
    <!--    </tab-bar-item>-->
    <!--    <tab-bar-item v-if="courseShow" path="/course" active-color="deepskyblue">-->
    <!--      <img slot="item-icon" src="~assets/img/tabbar/class.svg" alt="">-->
    <!--      <img slot="item-icon-active" src="~assets/img/tabbar/class_active.svg" alt="">-->
    <!--      <div slot="item-text">课程</div>-->
    <!--    </tab-bar-item>-->
    <!--    <tab-bar-item v-if="studentShow" path="/student" active-color="cornflowerblue">-->
    <!--      <img slot="item-icon" src="~assets/img/tabbar/student.svg" alt="">-->
    <!--      <img slot="item-icon-active" src="~assets/img/tabbar/student_active.svg" alt="">-->
    <!--      <div slot="item-text">学生管理</div>-->
    <!--    </tab-bar-item>-->
    <!--    <tab-bar-item v-if="teachersShow" path="/teachers" active-color="#ffd942">-->
    <!--      &lt;!&ndash;    <tab-bar-item path="/teachers" active-color="#ffd942" bcColor="lightgoldenrodyellow">&ndash;&gt;-->
    <!--      <img slot="item-icon" src="~assets/img/tabbar/teacher.svg" alt="">-->
    <!--      <img slot="item-icon-active" src="~assets/img/tabbar/teacher_active.svg" alt="">-->
    <!--      <div slot="item-text">教师管理</div>-->
    <!--    </tab-bar-item>-->
    <tab-bar-item v-if="adminShow" path="/DataCenter" active-color="cornflowerblue">
      <img slot="item-icon" src="~assets/img/tabbar/profile.svg" alt="">
      <img slot="item-icon-active" src="~assets/img/tabbar/profile_active.svg" alt="">
      <div slot="item-text">数据可视化</div>
    </tab-bar-item>
    <tab-bar-item v-if="profileShow" path="/profile" active-color="cornflowerblue">
      <img slot="item-icon" src="~assets/img/tabbar/profile.svg" alt="">
      <img slot="item-icon-active" src="~assets/img/tabbar/profile_active.svg" alt="">
      <div slot="item-text">管理中心</div>
    </tab-bar-item>
    <tab-bar-item v-if="stuProfileShow" path="/stuprofile" active-color="cornflowerblue">
      <img slot="item-icon" src="~assets/img/tabbar/profile.svg" alt="">
      <img slot="item-icon-active" src="~assets/img/tabbar/profile_active.svg" alt="">
      <div slot="item-text">我的</div>
    </tab-bar-item>
  </tab-bar>
</template>

<script>
import TabBar from "components/common/tabbar/TabBar";
import TabBarItem from "components/common/tabbar/TabBarItem";

export default {
  name: "MainTabBar",
  components: {
    TabBarItem,
    TabBar
  },
  computed: {
    selectShow() {
      return this.$cookies.get("user") === "student"
    },
    courseShow() {
      return this.$cookies.get("user") != "student"
    },
    adminShow() {
      return this.$cookies.get("user") === "admin"
    },
    profileShow() {
      return this.$cookies.get("user") != "student"
    },
    stuProfileShow() {
      return this.$cookies.get("user") === "student"
    },
    studentShow() {
      return this.$cookies.get("user") === "admin"
    }
  }
}
</script>

<style scoped>

</style>
